import styled from 'styled-components';

export const Container = styled.div`
    width: 100%;
`;



// WEBPACK FOOTER //
// ./src/UI/Containers/GymAdminPanel/MembershipTypes/style.js